import { IIndicatorRepository, IndicatorEntity, LayerEntity, LayerTypeEnum, ResponseValueObject } from '@gishub/domain'

export class IndicatorRepository implements IIndicatorRepository {
  async getIndicators(): Promise<ResponseValueObject<IndicatorEntity[]>> {
    const raw: any[] = [
      {
        id: 'predios-catastrales',
        name: 'Predios Catastrales',
        description: 'Distribución de predios catastrales y rurales registrados en el territorio nacional.',
        chartType: 'bar',
        source: 'MIDAGRI',
        layer: {
          name: 'Predios catastrales / rurales',
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          url: 'https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/12',
          fieldQuery: 'id_dist',
          categoryField: 'id_dist',
        },
      },
      {
        id: 'comunidades-campesinas',
        name: 'Comunidades Campesinas',
        description: 'Distribución de comunidades campesinas reconocidas y registradas por departamento.',
        chartType: 'bar',
        source: 'MIDAGRI',
        layer: {
          name: 'Comunidades campesinas',
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          url: 'https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/9',
          fieldQuery: 'nom_dpto',
          categoryField: 'estado',
        },
      },
      {
        id: 'comunidades-nativas',
        name: 'Comunidades Nativas',
        description: 'Distribución de comunidades nativas tituladas y registradas por departamento.',
        chartType: 'bar',
        source: 'MIDAGRI',
        layer: {
          name: 'Comunidades nativas',
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          url: 'https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/10',
          fieldQuery: 'nom_dpto',
          categoryField: 'etnia',
        },
      },
      {
        id: 'centros-poblados',
        name: 'Centros Poblados',
        description: 'Clasificación de centros poblados según área (urbano/rural) y provincia.',
        chartType: 'donut',
        source: 'MIDIS',
        layer: {
          name: 'Centros poblados',
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          url: 'https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/32',
          categoryField: 'area',
          fieldQuery: 'coddpto',
        },
      },
      {
        id: 'areas-naturales-protegidas',
        name: 'Áreas Naturales Protegidas',
        description: 'Distribución de las ANP según su categoría de conservación (Parque Nacional, Reserva Nacional, etc.).',
        chartType: 'donut',
        source: 'SERNANP',
        layer: {
          name: 'Áreas naturales protegidas',
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          url: 'https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/19',
          fieldQuery: 'anp_ubpo',
          categoryField: 'anp_cate',
        },
      },
      {
        id: 'concesiones-mineras',
        name: 'Concesiones Mineras',
        description: 'Distribución de concesiones mineras por tipo de actividad y estado operativo.',
        chartType: 'column',
        source: 'INGEMMET',
        layer: {
          name: 'Concesiones mineras',
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          url: 'https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/29',
          categoryField: 'LEYENDA',
          fieldQuery: 'DEPA',
        },
      },
      {
        id: 'proyectos-inversion',
        name: 'Proyectos de Inversión',
        description: 'Proyectos de inversión agrícola, infraestructura de riego y desarrollo rural (MIDAGRI).',
        chartType: 'donut',
        source: 'MIDAGRI',
        layer: {
          name: 'Proyecto de inversión',
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          url: 'https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/7',
          categoryField: 'ESTADO',
          fieldQuery: 'DPTO',
          hasProxy: false,
        },
      },
      {
        id: 'escuelas-minedu',
        name: 'Escuelas Públicas',
        description: 'Distribución y localización de locales escolares del Ministerio de Educación (MINEDU).',
        chartType: 'pie',
        source: 'MINEDU',
        layer: {
          name: 'Escuelas MINEDU',
          type: LayerTypeEnum.MapServer,
          visible: false,
          url: 'https://geocatmin.ingemmet.gob.pe/arcgis/rest/services/SERV_OTRAS_FUENTES/MapServer/29',
          categoryField: 'D_NIVEL_MOD',
          fieldQuery: 'UBIGEO',
          hasProxy: true,
        },
      },
      {
        id: 'centros-salud',
        name: 'Establecimientos de Salud',
        description: 'Distribución y categoría de los centros de salud registrados por el Ministerio de Salud (MINSA).',
        chartType: 'bar',
        source: 'MINSA',
        layer: {
          name: 'Centro de Salud - MINSA',
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          url: 'https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/27',
          categoryField: 'CATEGORÍA',
          fieldQuery: 'DEPARTAMEN',
        },
      },
    ];

    const indicators: IndicatorEntity[] = raw.map((item) => ({
      ...item,
      layer: new LayerEntity(item.layer),
    }));

    return new ResponseValueObject(true, indicators);
  }
}
